// Keyword extraction logic
export const keywords_en: string[] = [
  "fitting", "fittings",
  "slab", "concrete", "pvc", "pe", "kf", "bss",
  "tile", "plastic", "masonry", "sand",
  "pipe", "pipes", "pressure", "drainage",
  "tree", "trees", "foundation", "sewer",
  "trench", "manhole", "well", "soil",
  "sidewalk", "pavement", "asphalt", "brick",
  "vehicle", "truck"
];

export const keywords_nl: string[] = [
  // Dutch keywords - empty for now as requested
  "[put]", 
  "asfalt", 
  "baksteen", 
  "bakstenen", 
  "band", 
  "banden", 
  "begroeiing", 
  "bemaling", 
  "bermen", 
  "beton", 
  "betonband", 
  "betonbanded", 
  "betonput", 
  "betontegel", 
  "bomen", 
  "boom", 
  "buis", 
  "cunet", 
  "druk", 
  "fundering", 
  "gazon", 
  "gazonbanded", 
  "gitruit", 
  "hoge", 
  "hogedruk", 
  "hulpstuk", 
  "kolk", 
  "kunststof", 
  "leiding", 
  "metselwerk", 
  "pijp", 
  "put", 
  "putrand", 
  "pvc", 
  "riol", 
  "riool", 
  "rioolput", 
  "rubber", 
  "sleuf", 
  "sleuven", 
  "stelringen", 
  "straatkolk", 
  "tegel", 
  "tegels", 
  "vacuum", 
  "wagen", 
  "zagen", 
  "zand", 
  "pe",
  "pvc", "kf", "bss"
];

export function extract_keywords(sentence: string, lang: string): string[] {
  const keywords = lang === 'nl' ? keywords_nl : keywords_en;
  const words = sentence.toLowerCase().split(/\s+/);
  const foundKeywords: string[] = [];
  
  for (const word of words) {
    const cleanWord = word.replace(/[.,!?;:]/g, '');
    
    // First try exact word match
    if (keywords.includes(cleanWord)) {
      foundKeywords.push(cleanWord);
    } else {
      // If no exact match, try substring matching for keywords longer than 2 letters
      for (const keyword of keywords) {
        if (keyword.length > 2) {
          // Try both lowercase and original case for substring matching
          const keywordLower = keyword.toLowerCase();
          const keywordOriginal = keyword;
          
          if (cleanWord.includes(keywordLower) || cleanWord.includes(keywordOriginal)) {
            foundKeywords.push(keyword);
            // Don't break - continue looking for more keywords in this word
          }
        }
      }
    }
  }
  
  // Remove duplicates and return unique keywords
  const uniqueKeywords = foundKeywords.filter((keyword, index) => foundKeywords.indexOf(keyword) === index);
  return uniqueKeywords;
}
